import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'

import colors from '../../colors'
import Section from '../../components/Section/Section'

const Title = styled.h2`
    display: flex;      
    margin: 0px; 
    text-align:center;
    color: ${colors.darkgrey};
`

const H3 = styled.h3`
    color:${colors.darkgrey};
    margin:5px 0px 5px 0px;

    @media only screen and (max-width: 768px) {
        margin-top: 20px;
    }
`

const P = styled.p`
    margin: 0px;
`

const ContactInformation = styled.div`
    display: flex;
    flex-direction: row;
    align-items: baseline;
    width: 100%;

    @media only screen and (max-width: 768px) {
        flex-direction: column;
    }
`

const Contact = (props) => {
    return (
        <Section id="yhteys" direction="column" align="center" style={{ padding: '40px 0px' }}>
            <Title>Yhteys</Title>
            <p>Saukonojantie 58, 21420 Lieto
                <br/>
                Y-tunnus: 2121106-9    
            </p>
            <ContactInformation>
                    <Section direction="column" align="center" style={{ flex: 1 }}>
                        <H3>Myynti / Tarjous tiedustelut</H3>
                        <P>
                            Pertti Ylitalo<br/>
                            <a href="tel:0500 523975">0500 523975</a><br/>
                            <a href='mailto:ryklin@ryklin.fi'>ryklin@ryklin.fi</a></P>
                    </Section>
                    <Section direction="column" align="center" style={{ flex: 1 }}>
                        <H3>Laskutus</H3>
                        <P>
                            Marja Ylitalo<br/>
                            <a href="tel:0500 632085">0500 632085</a><br/>
                            <a href='mailto:ryklin@ryklin.fi'>ryklin@ryklin.fi</a>
                        </P>
                    </Section>

                    <Section direction="column" align="center" style={{ flex: 1 }}>
                        <H3>Verkkolaskut</H3>
                        <P>
                        Verkkolaskuosoite: 003721211069 <br />
                        Operaattoritunnus: 003708599126 <br />
                        Operaattori: Open Text Oy  
                        </P>
                    </Section>

            </ContactInformation>
            <h4>Löydät meidät myös: </h4>
            <a href="https://fi-fi.facebook.com/ryklin.fi/" target="_blank" rel="noreferrer"><FontAwesomeIcon style={{ fontSize: '45px', cursor: 'pointer', color: colors.orange}} icon={faFacebook} /></a>
        </Section>
    )
}

export default Contact